<template>
  <div>
    <a-modal v-model:visible="visible" title="脉诊记录" @ok="handleOk" okText="确认" cancelText="取消" :afterClose="closeModal" :cancelButtonProps="{ style: { display: 'none' }}" width="55vw">

      <a-table class="ant-table-striped" :columns="columns" :data-source="data" rowKey="id" :pagination="{pageSize:6 }" bordered>

        <template #operation="{ record }">
          <div class="flex_sa">

            <div class="editable-row-operations">
              <span>
                <a-popconfirm v-if="data.length" title="是否确认导入" @confirm="handleOk(record)" okText="确认" cancelText="取消">
                  <a>导入</a>
                </a-popconfirm>
              </span>
            </div>
          </div>
        </template>
      </a-table>

      <!-- <div style="text-align: center;margin-top: 20px;">
        <a-button type="primary" @click="visible2=true">新增权限</a-button>
      </div> -->
    </a-modal>
  </div>
  <!-- <addPrescription v-model="visible2" @getData="callbackData" /> -->
</template>

<script>
import { reactive } from "vue";
import { GetHealthAssessment, InsertHealthAssessment } from "/src/api/medicalRecord.js";
export default {
  components: {
  },
  data() {
    return {
      visible: this.modelValue,
      columns: [
        {
          title: "日期",
          key: "createdDate",
          dataIndex: "createdDate",
          width: "40%",
          slots: {
            customRender: "createdDate"
          }
        },
        {
          title: "脉诊结果",
          key: "syndromes",
          dataIndex: "syndromes",
          width: "40%",
          slots: {
            customRender: "syndromes"
          }
        },
        {
          title: "操作",
          dataIndex: "operation",
          width: "20%",
          slots: {
            customRender: "operation"
          }
        }
      ],
      data: [],
      labelCol: {
        span: 6,
      },
      wrapperCol: {
        span: 14,
      },
    };
  },
  emits: ['update:modelValue'],
  created() {

  },
  mounted() {
    // this.detail()
  },
  activated() {
  },
  //获取父元素传值
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
    customerId: {
      type: Number,
      default: -1
    },
    medicalRecordUuid: {
      type: String,
      default: ""
    }
  },
  computed: {
  },
  methods: {
    async detail() {
      let res = await GetHealthAssessment({ customerId: this.customerId })

      console.log(res);
      // console.log(res)
      if (res.errCode == 0) {
        this.data = res.data
      } else {
        this.$message.error("详情查询失败", function () { });
      }
    },
    async handleOk(record) {
      let _this = this;
      let res = await InsertHealthAssessment({ healthAssessmentId: record.id, uuid: this.medicalRecordUuid })
      if (res.errCode == 0) {
        _this.$message.success("关联成功", function () { });
        this.emitCallback()
      }
    },
    emitCallback() {
      this.$emit("healthAssessmentCallBack");
      this.closeModal()
    },
    async onDelete(id) {

      let res = await Delete({ id })
      if (res.errCode == 0) {
        this.data = this.data.filter(function (item) {
          return item.id !== id;
        });
      }

    },
    closeModal() {
      this.$emit('update:modelValue', false);
      //   if (this.reload) {
      //     this.$emit("reload")
      //   }
    },

  },
  watch: {
    customerId(val) {
      this.detail()
    },
    modelValue(val) {
      this.visible = val
    },
  }
};
</script>

<style scoped>
.head {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head span {
  font-weight: bold;
  margin-right: 10px;
}
.head2 {
  display: flex;
  margin-bottom: 20px;
  justify-content: center;
  align-items: center;
}
.head2 span {
  font-weight: bold;
  margin-right: 10px;
}
</style>
